'use strict';

module.exports = function(str, isXhtml) {
    var breakTag = (isXhtml || typeof isXhtml === 'undefined') ? '<br />' : '<br>';
    return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/nl2br/index.js
// module id = 53Z/
// module chunks = 4